var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map",attrs:{"id":"map"}},[(_vm.img)?_c('img',{attrs:{"src":_vm.img}}):_c('img',{attrs:{"src":_vm.defaultImg}})])
}
var staticRenderFns = []

export { render, staticRenderFns }